import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { ServiceContainerProps as Props } from '../../../../shared/types/props/services';

const ServiceContainer = styled.div<Props>`
  align-items: center;
  border: ${2 * Screen.widthRatio}px solid ${Colors.light};
  border-radius: ${8 * Screen.widthRatio}px;
  display: flex;
  height: ${28 * Screen.widthRatio}px;
  justify-content: center;
  margin-right: ${8 * Screen.widthRatio}px;
  opacity: ${(props) => (props?.active ? 1 : 0.3)};
  width: ${28 * Screen.widthRatio}px;
`;

export default ServiceContainer;
